// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__11qr2","notes":"Notes_notes__3fYZO"};